// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"lK-z","carouselContainer":"mK-z"};